import React, { useCallback, useEffect, useState } from 'react';
import Tools from '../../../core/Misc/Tools';
import { focusFirstElement, updateElementFocus } from '../../../misc/helpers';
import './Aar.css';
import GeneralButton from './GeneralButton';
import AarDescription from './AarDescription'
import $ from 'jquery';
import { shadow } from '@ionic/core/dist/types/utils/transition/ios.transition';
var elToFocus: any = null;
const Aar = (obj: any) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	var focusEl: any = null;
	const handleKey = useCallback((e: any) => {
		if (e.keyCode === 9) {//focus trap to prevent tabbing throught the element behind the popup
			let focusableParent = document.querySelector('.aar-container');
			if (!focusableParent) return;
			let focusable = Array.prototype.slice.call(focusableParent.querySelectorAll('p'))
			.concat(Array.prototype.slice.call(document.querySelectorAll('.aar-single-action-item-header')))
			.concat(Array.prototype.slice.call(document.querySelectorAll('.aar-container .general-btn-background')));
			updateElementFocus(e, focusable, focusableParent);

			// if(focusable[0] === document.activeElement && elToFocus) {
			// 	setTimeout(() => {
			// 		elToFocus.focus();
			// 	}, 1000);
			// } else if(focusable[0] !== document.activeElement){
			// 	elToFocus = document.activeElement;
			// }
		}
	}, []);

	useEffect(() => {
		console.log('binded event')
		window.document.addEventListener('keydown', handleKey);
		focusFirstElement(handleKey);
	}, [obj]);

	useEffect(() => {
		if(focusEl) {
			console.log('focusing element');
			console.log(focusEl);
			focusEl.focus();
		}

	}, [focusEl]);
	useEffect(() => {
		// setTimeout(() => {
		// 	// var result = document.getElementsByClassName('aar-single-action-item');
		// 	// var index = indxToUpdate - 1;
		// 	// if(index < result.length && index >= 0) {
		// 	// 	(result[index].querySelector('aar-single-action-item-txt') as any).focus();
		// 	// }
		// }, 500);
		// if(elToFocus) {
		// 	elToFocus.focus();
		// }
	}, [elToFocus])

	return (
		<div className="ui-container feedback-container aar-container aar-disable-select">
			<p className="aar-title" tabIndex={0}>Scenario {obj.parameters.data.scenario}  Complete</p>
			<p className="aar-breakdown-txt" tabIndex={0}>Scene Breakdown:</p>
			<p className="aar-passed-txt" tabIndex={0}>{obj.parameters.data.passed ? 'CONGRATULATIONS! You have saved the victim. Here is a breakdown of your efforts:' :
				'Unfortunately you failed to save the victim or failed to follow the correct bleeding control procedures. Here is a breakdown of your efforts:'}</p>
			<div className="aar-final-time-container" tabIndex={0}>
				<p className="aar-final-time-title">FINAL TIME</p>
				<p className="aar-final-time-desc">{obj.parameters.data.time}</p>
			</div>
			<div className="aar-action-items-container">
				{
					obj.parameters.data.actionItems.map((ai: any, index: any) => {
						return (
							ai.showInScenarios.indexOf(obj.parameters.data.currentScenario) === -1 ? (null) : (
								<div key={Tools.generateGuid()} className="aar-single-action-item" style={{
									height: ai.isExpanded ? '180px' : '83px'
								}}>
									<div className="aar-single-action-item-header" tabIndex={0} aria-label={(ai.isCorrect ? 'Correct ' : 'Incorrect ') + ai.title} onClick={() => {
											if (typeof ai.isExpanded === 'undefined') {
												ai.isExpanded = false;
											}
											ai.isExpanded = !ai.isExpanded;

											// for(var indx = 0; indx < obj.parameters.data.actionItems.length; indx++) {
											// 	obj.parameters.data.actionItems[indx].selectedIndx = -1;
											// }

											// ai.selectedIndx=index;
											window['selectedArrItemId' as any] = index;
											setForceUpdate(!forceUpdate);
										}}>
										<img alt="" className="aar-single-action-item-img" src={'assets/img/AAR/' + (ai.isCorrect ? 'header-correct' : 'header-incorrect-highlight') + '.png'} />
										<p className="aar-single-action-item-title">{ai.title}</p>
									</div>

									{/* {ai.isExpanded?
										(
											<div className="aar-single-action-item-txt">
												<p tabIndex={0}>{ai.isCorrect ? ai.correctFeedback : ai.incorrectFeedback}</p>
											</div>
										) :
										(
											null
										)} */}

									<AarDescription selectedIndx={ai.selectedIndx} id={index} isCorrect={ai.isCorrect} correctFeedback={ai.correctFeedback} incorrectFeedback={ai.incorrectFeedback} show={ai.isExpanded}></AarDescription>
								</div>
							)
						)
					})
				}
			</div>
			<GeneralButton text="MAIN MENU"
				onClick={obj.parameters.onDone} style={{
					position: 'relative',
					top: '116px',
					width: '162px',
					margin: '0 auto'
				}}></GeneralButton>
		</div>
	);
};

export default Aar;
